import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-small-loader-component',
    templateUrl: './small-loader.component.html',
    styleUrls: [],
})
export class SmallLoaderComponent {
    @Input() visibility: boolean;
    @Input() content: string;
    @Input() success = false;
}
